import UnknownScene from '@works-web/settings/scenes/unknown';
import PropTypes from 'prop-types';
import React from 'react';
import { sendNeloLog } from '~/settings/__modules__/utils/sendlog';

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err, info) {
    console.error(err, info);
    if (this.props.logError) {
      const errInfo = {
        logLevel: 'error',
        body: {
          ts: Date.now(),
          type: 'js_error',
          detail: err.message + `: ${err.stack + ''}` + JSON.stringify(err),
          url: window.location.href,
          insideIframe: window.parent && window.parent !== window,
        },
      };
      sendNeloLog(errInfo);
    }
  }

  render() {
    if (this.state.hasError) return <UnknownScene />;
    return this.props.children;
  }
}

AppErrorBoundary.propTypes = {
  logError: PropTypes.bool,
  children: PropTypes.PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
